import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=0dc3957a"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IdFaqParagraph: require('/workspace/components/faq/Paragraph.vue').default,IdFaqInfoBox: require('/workspace/components/faq/InfoBox.vue').default,IdFaqImage: require('/workspace/components/faq/Image.vue').default,IdFaqInfoBoxList: require('/workspace/components/faq/InfoBoxList.vue').default,IdFaqInfoBoxShortcutsList: require('/workspace/components/faq/InfoBoxShortcutsList.vue').default,IdFaqInfoBoxResizeList: require('/workspace/components/faq/InfoBoxResizeList.vue').default,IdFaqQuestion: require('/workspace/components/faq/Question.vue').default})
